"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteStartPopUp = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _PAUL_Logo_blue = _interopRequireDefault(require("paul-core-package/dist/images/PAUL_Logo_blue.svg"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../utils/constants");
var _selectors = require("../../redux/selectors");
var _actions = require("../../redux/actions");
var _SkeletonText = require("../SkeletonText");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/** @todo remover absolute path */

const SiteStartPopUp = () => {
  const [progress, setProgress] = _react.default.useState(0);
  const [loading, setLoading] = (0, _react.useState)(false);
  const site = (0, _reactRedux.useSelector)(_selectors.getDataSite);
  const dispatch = (0, _reactRedux.useDispatch)();
  /** @todo remove transfer number */
  const {
    82: CONTINUE,
    SITE_START_TEXT_1,
    SITE_START_TEXT_2
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const handleSubmit = () => {
    setLoading(true);
    dispatch((0, _actions.makeSiteApproveAction)({
      siteId: site.id
    }));
  };

  /** temporary for show process */
  (0, _react.useEffect)(() => {
    let timer = null;
    const showProgress = () => {
      timer = setInterval(() => {
        setProgress(oldProgress => {
          if (oldProgress === 100) {
            clearInterval(timer);
          }
          return oldProgress + 1;
        });
      }, _constants.startSiteTime / 100);
    };
    if (loading) {
      showProgress();
    }
    return () => {
      clearInterval(timer);
    };
  }, [loading]);
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    sx: {
      padding: 5,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      maxWidth: 480,
      borderRadius: 2,
      boxShadow: '0px 20px 24px -6px rgba(16, 24, 40, 0.05), 0px 8px 8px -4px rgba(16, 24, 40, 0.01)'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    py: 5,
    sx: {
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _PAUL_Logo_blue.default,
    alt: "PAUL"
  })), site.id ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.CardContent, {
    sx: {
      px: 0,
      pt: 4,
      pb: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body1",
    sx: {
      fontSize: 16,
      color: _constants.colors['main-color-cl-99']
    }
  }, /*#__PURE__*/_react.default.createElement(_SkeletonText.SkeletonText, {
    showIf: SITE_START_TEXT_1,
    width: 100
  }, SITE_START_TEXT_1), ' ', /*#__PURE__*/_react.default.createElement("b", null, tV(site.thingSiteAddress)), " in", /*#__PURE__*/_react.default.createElement("b", null, ' ', tV(site.thingZIPCode), " ", tV(site.thingCity)), /*#__PURE__*/_react.default.createElement(_SkeletonText.SkeletonText, {
    showIf: SITE_START_TEXT_2,
    width: 100
  }, SITE_START_TEXT_2))), /*#__PURE__*/_react.default.createElement(_material.CardActions, {
    sx: {
      p: 0,
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      my: 5,
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    }
  }, loading ? /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.LinearProgress, {
    variant: "determinate",
    sx: {
      color: _constants.colors['main-color-cl-30']
    },
    value: progress
  })) :
  /*#__PURE__*/
  // <CircularProgress sx={{ color: colors['main-color-cl-30'] }} />
  _react.default.createElement(_material.Button, {
    variant: "contained",
    size: "large",
    disableElevation: true,
    sx: {
      bgcolor: _constants.colors['main-color-cl-30'],
      textTransform: 'inherit',
      fontWeight: 700,
      fontSize: 16
    },
    onClick: handleSubmit
  }, CONTINUE || /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    width: 50
  }))))) : null);
};
exports.SiteStartPopUp = SiteStartPopUp;